import React, { Component } from 'react'
import PubSub from 'pubsub-js'
import LoginAccountInput from "../LoginAccountInput";
import LoginThirdBtn from "../LoginThirdBtn";
import ImgCodeInput from "../ImgCodeInput";
import BsyBtn from "../BsyBtn";
import BsyRadioItem from "../BsyRadioItem";
import tipAlert from "../BsyAlertTip/Staticize";
import './index.css'
import i18n from "i18next";

export default class LoginCode extends Component {
    state = {
        errorInput: false,
        lang: React.cookie.load("bby_lang") ? React.cookie.load("bby_lang") : window._bby_config.lang,
        languageShow: false,
        check: true,
        hasCode: false,
        errMsg: '',
        corpLogoSwitch: true,
        siteName: window.title,
        corpLogoImageUrl: `${window.media_domain}/logo.png`,
    }
    hideAllMenu = (event) => {
        event.stopPropagation()
        const { languageShow } = this.state
        if (languageShow === true) {
            this.setState({ languageShow: false })
        }
    }
    languageShow = (event) => {
        event.stopPropagation()
        const { languageShow } = this.state
        this.setState({ languageShow: !languageShow })
    }

    languageChange = (event) => {
        const s = event.target.parentNode.children;
        for (let i = 0; i < s.length; i++) {
            s[i].classList.remove("select");
        }
        event.target.classList.add("select");
        const n = event.target.classList[0];
        React.cookie.save("bby_lang", n)
        i18n.changeLanguage(n);
        this.setState({ lang: n })
    }

    GetQueryString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }

    accountValue = (ref) => {
        this.account = ref
    }
    imgCodeValue = (ref) => {
        this.imgCode = ref
    }
    componentDidMount() {
        const el = document.getElementsByClassName("LoginCode")[0];
        document.addEventListener('click', this.hideAllMenu);
        el.addEventListener("keyup", (event) => {
            if (event.keyCode === 13) {
                this.codeLogin()
            }
        })
    }

    componentWillUnmount() {
        const el = document.getElementsByClassName("LoginCode")[0]
        el.removeEventListener("keyup", null)
    }
    codeLogin = () => {
        if(!this.state.hasCode){
            return
        }
        if(window.sitesetting.protocol_switch !== "0") {
            if (!this.CheckValue.getValue()) {
                tipAlert({
                    type: "error",
                    msg: React.language('m.tiaokuan.entry.error')
                })
                return
            }
        }

        this.setState({
            errorInput: false,
            errMsg: '',
        })
        const code = this.imgCode.getValue();
        const { changeContCodePage } = this.props
        const accountValue = this.account.getValue();
        const mode = accountValue.accountType === "email" ? "email_code" : "mobile_code";
        const data = accountValue.accountType === "email" ? {
            "mode": mode,  //激活账号的验证码传 active_code 找回密码getpwd_mobile_code
            "data": {
                "email": accountValue.value,
                "code": code.value //图形验证码
            }
        } : {
            "mode": mode,  //激活账号的验证码传 active_code 找回密码getpwd_mobile_code
            "data": {
                "mobile": accountValue.value,
                "country_code": accountValue.countryCode,  //地区编码
                "code": code.value //图形验证码
            }
        }
        React.axios('/user/signin', data).then(res => {
            if (res.data.code === 200) {
                tipAlert({
                    type: "success",
                    msg: res.data.msg
                })
                changeContCodePage("EntryInputCodeShow")
                PubSub.publish('codeCont', { value: accountValue });
            } else if (res.data.code === 206) {
                this.imgCode.changeCode()
                tipAlert({
                    type: "error",
                    msg: res.data.msg
                })
                this.setState({
                    errorInput: true,
                    errMsg: res.data.msg,
                })
            }else if(res.data.code===400){
                tipAlert({
                    type: "error",
                    msg : res.data.msg
                })
            }
        }).catch(res => {
            const res1 =  res.response ? res.response.data : res.data;
            this.imgCode.changeCode()
            if (res1.toString().indexOf('"Message":"OK"') === -1) {
                if (res1.toString().indexOf('code')) {
                    // tipAlert({
                    //     type: "error",
                    //     msg: res1.msg
                    // })
                    this.setState({
                        errorInput: true,
                        errMsg: res1.msg,
                    })
                }
                else {
                    // tipAlert({
                    //     type: "error",
                    //     msg: React.language("System.error")
                    // })
                    this.setState({
                        errorInput: true,
                        errMsg: React.language("System.error"),
                    })
                }
            } else {
                tipAlert({
                    type: "success",
                    msg: res1.msg
                })
                changeContCodePage("EntryInputCodeShow")
                PubSub.publish('codeCont', { value: accountValue });
            }
        })
    }

    getCheckValue = (ref) => {
        this.CheckValue = ref
    }

    changeCode = (code) =>{
        this.setState({hasCode: code !== ""})
    }


    render() {
        const { rightTitle, changeContModePage, isMirror, isCorp, customLoginConfig } = this.props;
        const { errorInput, errMsg, lang, languageShow, check, hasCode, siteName, corpLogoImageUrl, corpLogoSwitch } = this.state;
        let mode = (window.data_config.mobileCodeLogin && window.data_config.emailCodeLogin) ? "" : window.data_config.mobileCodeLogin ? "mobile" : window.data_config.emailCodeLogin ? "email" : ""
        let phone = "";
        if (this.GetQueryString('type') === 'register' && this.GetQueryString('phone')) {
            phone = this.GetQueryString('phone')
            mode = "mobile"
        }
        const modeBtnShow={
            dingdingShow:true,
            workWechatShow:true,
            qyWechatShow:true,
            feishuShow:true,
            qyzjWechatShow:true,
            wechatShow:true,
            LoginAccountPasswordShow: true,
            LoginCodeShow: false,
            ssoShow: true,
        }
        return (
            <div className="LoginCode">
                <div className="loginContentBox">
                    {!isMirror ? <div className="title">{rightTitle}</div> : <div className="logo">
                        {corpLogoSwitch && <>
                            <img src={corpLogoImageUrl} alt="" />
                            <span>{siteName}</span>
                        </>}
                    </div>}
                    <div className="error-msg">
                        {errMsg}
                    </div>
                    <LoginAccountInput value={phone ? phone : this.account ? this.account.getValue().value : ""} error={errorInput} mode={mode} getValue={this.accountValue} />
                    <ImgCodeInput error={errorInput} getValue={this.imgCodeValue} changeCode={this.changeCode} />

                    {window.sitesetting.protocol_switch !== "0" && <div className="agreeCon">
                        <div className="agreeCheckCon">
                            <BsyRadioItem getValue={this.getCheckValue} value={check} text={'order.contract.accept'} />
                        </div>
                        <div className="readAgreeCon">
                            <a rel="noreferrer" href={window.rootDirectroy +'/agreement/termsOfService'} target="_blank">《网站服务条款》/</a>
                            <a rel="noreferrer" href={window.rootDirectroy +'/agreement/legalDeclarationClause'} target="_blank">《法律声明及隐私权政策》</a>
                        </div>
                    </div>}
                    <BsyBtn style={{ 'marginBottom': '1.25rem', 'marginTop': '1.25rem', 'opacity': hasCode ? '' : '0.3' }} onClick={this.codeLogin} text={React.language('m.code.send')} />
                </div>
                <LoginThirdBtn customLoginConfig={customLoginConfig} isCorp={isCorp} modeBtnShow={modeBtnShow} changeContModePage={changeContModePage} />
            </div>
        );
    }
}